import {
  FETCH_ONDUTYTYPES_SUCCESS,
  CREATE_ONDUTYTYPE,
  UPDATE_ONDUTYTYPE,
  DELETE_ONDUTYTYPE,
  SET_ONDUTYTYPE_ID
} from "actions/types";

import {
  onDutyTypesRead,
  onDutyTypeCreate,
  onDutyTypeUpdate,
  onDutyTypeDelete,
} from "../api";
import {
  dataFailure,
  dataSuccess,
} from "./general";


const fetchOnDutyTypesSuccess = (values) => {
  return {
    type: FETCH_ONDUTYTYPES_SUCCESS,
    payload: values,
  };
};

export const fetchOnDutyTypes = (values) => {
  return async (dispatch) => {
    try {
      const JSONData = await dispatch(onDutyTypesRead(values));
      await dispatch(fetchOnDutyTypesSuccess(JSONData));
    } catch (err) {
      await dispatch(dataFailure(err.message));
    }
  };
};

const createOnDutyTypeData = (values) => {
  return {
    type: CREATE_ONDUTYTYPE,
    payload: values,
  };
};

export const createOnDutyType = (values) => {
  return async (dispatch) => {
    try {
      const JSONData = await dispatch(onDutyTypeCreate(values));
      await dispatch(createOnDutyTypeData(JSONData));
      await dispatch(dataSuccess());
    } catch (err) {
      await dispatch(dataFailure(err.message));
    }
  };
};

const updateOnDutyTypeData = (values) => {
  return {
    type: UPDATE_ONDUTYTYPE,
    payload: values,
  };
};

export const updateOnDutyType = (values) => {
  return async (dispatch) => {
    try {
      const JSONData = await dispatch(onDutyTypeUpdate(values));
      await dispatch(updateOnDutyTypeData(JSONData));
      await dispatch(dataSuccess());
    } catch (err) {
      await dispatch(dataFailure(err.message));
    }
  };
};

const deleteOnDutyTypeData = (values) => {
  return {
    type: DELETE_ONDUTYTYPE,
    payload: values,
  };
};

export const deleteOnDutyType = (values) => {
  return async (dispatch) => {
    try {
      await dispatch(onDutyTypeDelete(values));
      await dispatch(deleteOnDutyTypeData(values));
      await dispatch(dataSuccess());
    } catch (err) {
      await dispatch(dataFailure(err.message));
    }
  };
};

export const setOnDutyTypeId = (values) => {
  return {
    type: SET_ONDUTYTYPE_ID,
    payload: values,
  };
};